import { twMerge } from "tailwind-merge";
import Box from "../Box";

interface ResumeBoxProps {
  label?: string;
  value?: string | number | JSX.Element;
  boxClassName?: string;
  labelClassName?: string;
  valueClassName?: string;
}

const ResumeBox = ({ label, value, boxClassName, labelClassName, valueClassName }: ResumeBoxProps) => {
  return (
    <Box className={twMerge('rounded-xl flex flex-col gap-1 px-4 py-5', boxClassName)}>
      {label && <p className={twMerge('text-xs font-light', labelClassName)}>{label}</p>}
      {value && <p className={twMerge('text-sm font-medium', valueClassName)}>{value}</p>}
    </Box>
  );
};

export default ResumeBox;
